export default "__VITE_ASSET__CAnaYszR__"